export default __webpack_public_path__ + "static/tile-variant-dont-677f94010967062629d84423a1e8a065d7744b964ea2982d7bceabb4b89ebd1d.png";